// eslint-disable-next-line import-x/no-unresolved
import { useGetStreamRestream } from '@vlabs/api/artemy/client';
// eslint-disable-next-line import-x/no-unresolved
import { getRestreamPlaylistUrl } from '@vlabs/api/axios/point2-client';

import { buildRestreamParams, isRetranslatorDisabledError } from './streamRestream';

const RESTREAM_RETRY_COUNT = 3;

// ponytail: тонкая обёртка над react-query — ретраи и refetch даёт сам query;
// hls-подключение и статусы плеера — в StreamPlayer (apps/point3).
// enabled — включает запрос (страница потока дёргает рестрим только при открытии модалки зон)
export const useStreamRestream = (streamId, quality, enabled = true) => {
  const query = useGetStreamRestream(streamId, buildRestreamParams(quality), {
    query: {
      enabled,
      retry: (failureCount, error) => {
        if (isRetranslatorDisabledError(error)) return false;
        return failureCount < RESTREAM_RETRY_COUNT;
      },
      // Подключение — только при первом запуске страницы и явной кнопке «Подключение»;
      // фокус окна/восстановление сети не должны дёргать restream
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  });

  let status = 'success';
  if (query.isError) status = 'error';
  if (query.isLoading) status = 'loading';

  // Плейлист отдаётся url на loopback бэкенда (127.0.0.1:8888) — пересобираем на прокси-путь
  // ретранслятора (/api/retranslator, env VITE_RETRANSLATOR_PATH), чтобы hls.js и его сегменты
  // ходили через фронтовый origin, а не на недоступный адрес бэкенда
  let retransmission = query.data;
  if (query.data) {
    retransmission = { ...query.data, url: getRestreamPlaylistUrl(query.data.url) };
  }

  return {
    retransmission,
    status,
    reconnect: query.refetch,
  };
};
